import React from "react"
import { Container, Col } from "react-bootstrap"
import { AllDeliveryOrdersStaff } from "../../Components/Admin/AllordersDeliveryStaff"
import StaffComponent from "../../Components/Admin/StaffPage"
import AllDeliveryOrdersStaff2 from "../../Components/Admin/AllordersDeliveryStaff2"
const DeliveryOrdersStaff2 = () => {
  return (
    <Container fluid className="px-0">
      <Col sm="12" xs="12" className="px-0">
        <AllDeliveryOrdersStaff2 />
      </Col>
    </Container>
  )
}
export default DeliveryOrdersStaff2
